import { Link } from 'react-router-dom'
import { CloudArrowUpIcon } from '@heroicons/react/24/outline'

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <CloudArrowUpIcon className="h-8 w-8 text-primary-600" />
            <span className="text-xl font-bold text-gradient">CloudShare</span>
          </Link>
          
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-gray-700 hover:text-primary-600 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              About
            </Link>
          </nav>
          
          <Link
            to="/"
            className="btn-primary"
          >
            Upload File
          </Link>
        </div>
      </div>
    </header>
  )
} 